import { Badge, Button, DatePicker, Divider, Dropdown, Form, Input, Layout, Menu, message, Modal, Pagination, Popover, Select, Space, Table, Tabs, Tag } from "antd"
import { Content } from "antd/es/layout/layout";
import { useCallback, useEffect, useRef, useState } from "react";
import { NewKeyModal } from "./newKey.modal";
import { NewKeyGroupModal } from "./newKeyGroup.modal";
import { useLazyQuery, useQuery } from "@apollo/client";
import { getAllKeyGroupsQuery, getAllKeysQuery } from "../../util/query/keyRegister.query";
import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBox, faBoxesStacked, faCheckCircle, faClipboardCheck, faClose, faEdit, faEllipsisVertical, faGroupArrowsRotate, faKey, faRotate, faRotateLeft, faRotateRight, faSearch, faTrashCan, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import KeyDetailPage from "./keyDetail.page";
import { KeyRegisterStatus } from "./keyRegisterStatus";
import { AppstoreAddOutlined, AuditOutlined, CaretDownFilled, ExclamationOutlined, FilterOutlined, MoreOutlined, QuestionCircleOutlined, RollbackOutlined, SearchOutlined, SwapOutlined, UserAddOutlined, WarningOutlined } from "@ant-design/icons";
// import { ExclamationCircleOutlined, QuestionCircleOutlined, RecycleIcon } from "@ant-design/icons";
import Swal from "sweetalert2";
import { useMutation } from "@apollo/client";
// import { lostKeyGroupMutation, requestReturnKeyGroupMutation, returnKeyGroupMutation } from "../../util/mutation/keyRegister.mutation";
import { getKeyGroupDetailByIdQuery } from '../../util/query/keyRegister.query';
import { KeyActionModal } from "./keyActionModal";
import { getAgencies } from "@src/util/query/agency.query";
import { debounce } from 'lodash';
import { GetEmployeeRecord } from "@src/util/query/employee.query";
import { assignKeyGroupMutation, assignKeyMutation, lostKeyGroupMutation, lostKeyMutation, markasFoundKeyMutation, markAsFoundKeyGroupMutation, requestReturnKeyGroupMutation, requestReturnKeyMutation, returnKeyGroupMutation, returnKeyMutation, returnKeyToCustomerMutation, moveKeyToGroupMutation, addKeyToGroupMutation, makeAuditRequestMutation, DELETE_KEY_GROUP_Mutation } from '../../util/mutation/keyRegister.mutation';
import TextArea from "antd/es/input/TextArea";
import Spinner from "@src/components/spinner";
import { KeyTransactionHistory } from "./keyTransactions";
import { FilterPopover } from "./filterPopover";
import { ReplaceKeyModal } from "./replaceKey.modal";
import { ReportKeyDamagedModal } from "./reportKeyDamaged.modal";
import { TerminateSiteModal } from "../site/siteDetailPage/component/terminateSiteModal";
import { SiteTerminationCheckModal, TERMINATED_STATUS, TERMINATION_PENDING_STATUS } from "../site/siteDetailPage/component/siteTerminationCheckModal";
import { GetSiteTerminationImpactQuery } from "@src/util/query/site.query";
import { UpdateSingleSiteMutation } from "@src/util/mutation/site.mutation";
import { formatDate } from '@src/util/formatDate';




export const KeyRegisterPage = ()=>{

    const [currentViewStatus, setCurrentViewStatus] = useState("allKey");
    const [searchText, setSearchText] = useState('');
    // Debounced-committed search value actually sent to the server - kept separate from
    // searchText (which drives the input) so the fetch effect below isn't retriggered on every
    // keystroke, only once typing settles.
    const [debouncedSearchValue, setDebouncedSearchValue] = useState(null);
    const [newKeyModal, setNewKeyModal] = useState(false);
    const [newKeyGroupModal, setNewGroupModal] = useState(false);
    const [groupToBeEdit, setGroupToBeEdit] = useState(null);
    const [keyToBeEdit, setKeyToBeEdit] = useState(null);


    const [dataSource, setDataSource] = useState([]);
    const [hoveredRow, setHoveredRow] = useState(null);
    const navigate = useNavigate();

    const [keyDetailModal, setKeyDetailModal] = useState({modal: false, id: null});

    const [keyData, setKeyData] = useState(null);

    const [replaceKeyModal, setReplaceKeyModal] = useState(false);
    const [reportDamagedModal, setReportDamagedModal] = useState(false);

    // "Return to Customer" -> "is this site also terminated?" flow (see
    // handleReturnToCustomerClick). `terminateSiteForKey` holds the site while TerminateSiteModal
    // (asking for the contract end date) is open; once confirmed, `terminationImpact` drives the
    // same SiteTerminationCheckModal Site Detail/Mobile Services already use - its own Site key
    // section handles actually returning this key once it's resolved as In House.
    const [terminateSiteForKey, setTerminateSiteForKey] = useState(null); // {_id, sitename} | null
    const [terminationImpact, setTerminationImpact] = useState(null);
    const [getSiteTerminationImpact, {loading: terminationCheckLoading}] = useLazyQuery(GetSiteTerminationImpactQuery, {fetchPolicy: 'network-only'});
    const [updateSingleSiteForTermination] = useMutation(UpdateSingleSiteMutation);

// needs to implement this

    const [requestKeyReturn, {loading: requestKeyReturnLoading}] = useMutation(requestReturnKeyMutation);

    const [returnKey, {loading: returnKeyLoading}] = useMutation(returnKeyMutation);

    const [lostKey, {loading: lostKeyLoading}] = useMutation(lostKeyMutation);

    const [markAsFoundKey, {loading: markAsFoundKeyLoading}] = useMutation(markasFoundKeyMutation);

    const [returnKeyToCustomer, {loading: returnKeyToCustomerLoading}] = useMutation(returnKeyToCustomerMutation)

    const [moveKeyToGroup, {loading: moveKeyToGroupLoading}] = useMutation(moveKeyToGroupMutation);

    const [addKeyToGroup, {loading: addKeyToGroupLoading}] = useMutation(addKeyToGroupMutation, {
        onCompleted: (data)=>{
            message.success(data?.returnKeyGroup?.message || "Key returned successfully");
            allKeyGroupDataRefetch();
        },
        onError: (error)=>{
            message.error(error?.message || "Failed to return key");
        }
    });
    
    const [makeAuditRequest, {loading: makeAuditRequestLoading}] = useMutation(makeAuditRequestMutation);
    
    const handleKeyActionSubmit = async (type, form, customerId=null) => {
        try{
            const values = await form.getFieldsValue();
             // Handle form submission for different actions
            switch(type){
                case 'Request Return':
                    // Call API to request return with values
                    await requestKeyReturn({variables: {input: {...values, _id: keyData._id}}});
                    break;
                case 'Audit Request':
                    await makeAuditRequest({variables:{
                        input: {
                            ...values,
                            _id: keyData?._id
                        }
                    }});
                    message.success("Audit request submitted successfully");
                    break;
                case 'Report Lost':
                    // Call API to report key as lost with values
                    await lostKey({variables: {input: {...values, _id: keyData._id}}});
                    break;
                case 'Returned':
                    // Call API to mark key as returned with values
                    returnKey({variables: {input: {...values, _id: keyData._id}}});
                    break;

                case 'Return to Customer':
                    // Call API to mark key as returned with values
                    await returnKeyToCustomer({variables: {input: {...values, _id: keyData._id, customerId}}});
                    break;

                case 'Mark as found':
                    await markAsFoundKey({
                        variables:{
                            input:{
                                ...values,
                                _id: keyData._id
                            }
                        }
                    })
                    break;

                case 'Add To Group':
                    await addKeyToGroup({
                        variables:{
                            
                                ...values,
                                keyId: keyData._id
                        }
                    })
                    break;



                case 'Move Key Group':
                    await moveKeyToGroup({
                        variables:{
                            
                                ...values,
                                keyId: keyData._id
                            
                        }
                    })
                    break;


                default:
                    break;
            }
            setActionModalVisible(false);
            form.resetFields();

            

        }catch (error){
            console.error("Action Failed:", error, keyGroupData);
            message.error(error?.message || "Failed to perform action");
            return;
        }finally{
            await allKeyRefetch();
        }

    };

    // "Return to Customer" only ever appears once a key is already In House (see the actions menu
    // below), but that alone doesn't mean the site's contract is actually ending too - most of the
    // time this is just a key coming back for its own sake. Ask first; only when the answer is
    // "yes, the site's terminating too" does this hand off to the full termination-check flow
    // instead of the plain single-key return.
    //
    // ... unless the site's already Termination Pending (or fully Terminated) - that already means
    // we're mid-termination and just waiting on this very key, so asking again would be redundant.
    // Only ask when the site's still Active.
    const handleReturnToCustomerClick = async (record) => {
        const siteStatus = record?.record?.site?.sitestatus;
        const siteAlreadyTerminating = [TERMINATED_STATUS, TERMINATION_PENDING_STATUS].includes(siteStatus);

        if(siteAlreadyTerminating){
            setKeyData(record);
            handleAction("Return to Customer");
            return;
        }

        const confirmResult = await Swal.fire({
            title: "Is this site's contract also ending?",
            text: "If the site's contract is ending too, we'll walk through the full termination check (guarding duties, mobile services, rota) and return this key to the customer as part of it.",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes, terminate the site too",
            cancelButtonText: "No, just return this key",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#6c757d",
        });

        if(!confirmResult.isConfirmed){
            setKeyData(record);
            handleAction("Return to Customer");
            return;
        }

        setTerminateSiteForKey({_id: record?.record?.siteId, sitename: record?.site});
    };

    const handleTerminateSiteForKeyConfirm = async (contractEndDate) => {
        const siteId = terminateSiteForKey?._id;
        setTerminateSiteForKey(null);
        const res = await getSiteTerminationImpact({variables: {siteId, contractEndDate}});
        setTerminationImpact({...(res?.data?.getSiteTerminationImpact ?? null), siteId, contractEndDate});
    };

    const handleTerminationProceed = async (finalStatus) => {
        try{
            const res = await updateSingleSiteForTermination({
                variables:{
                    input:{
                        _id: terminationImpact?.siteId,
                        properties: [
                            { name: "sitestatus", value: finalStatus, metadata: true },
                            { name: "contractenddate", value: terminationImpact?.contractEndDate, metadata: true },
                        ],
                        statusChangeSource: "key-register",
                    }
                }
            });
            if(!res?.data?.updateSite?.success){
                message.error(res?.data?.updateSite?.message || "Something went wrong while terminating the site");
                return;
            }
            message.success("Site was terminated successfully");
            setTerminationImpact(null);
            await allKeyRefetch();
        }catch(err){
            message.error(err?.message || "Something went wrong while terminating the site");
        }
    };


    const keyColumns = [
        {
            id: 0,
            title: "Assignee",
            dataIndex: "assignee",
            
            render: (text, record) => (
            <div style={{ whiteSpace: 'nowrap' }} onClick={()=>{
                record?.custodianType=="supplier"?
                navigate("/user/agency-detail/"+record?.record?.custodianId)
                :
                navigate("/user/employee-detail/"+record?.record?.custodianId)
            }}>
                <div style={{ fontWeight: 500,  }} className="link">{text} </div>
                <div style={{ fontSize: 13, color: '#9ca3af' }}>
                    {record?.custodianType}
                </div>
            </div>

      )
        },
        {
            id: 1,
            title: "Site",
            dataIndex: "site",
            render: (site, record)=>{
                console.log(hoveredRow, "hoveredRow")
                const isVisible = record?._id==hoveredRow
                return(
                    <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', gap:'8px'}}>

                        <div>

                            <div style={{flex:1, minWidth:0, wordBreak:'break-word'}}>{site}</div>
                            <div style={{ fontSize: 13, color: '#9ca3af' }}>
                                {record?.record?.site?.customername}
                            </div>
                        </div>

                        <div style={{flexShrink:0, whiteSpace:'nowrap', ...(isVisible?{visibility: 'visible'}: {visibility:'hidden'})}}>
                            <button className="sm-btn" onClick ={() =>{setKeyToBeEdit(record); setNewKeyModal(true)}}>Edit</button> &emsp;
                            <button className="sm-btn" onClick={()=>{setKeyDetailModal({modal: true, id: record?._id})}}>View</button>
                        </div>


                    </div>
                )
            }
        },
        {
            id: 2,
            title: "Post code",
            dataIndex: "postcode",
        },
        {
            id: 3,
            title: "Key Status",
            width:'150px',
            dataIndex: "status",
            render: (status, record) => {
                const color = KeyRegisterStatus[status?.toLowerCase()] || { bg: '#f3f4f6', text: '#374151' };
                return (
                    <span style={{
                        color: color.text, backgroundColor: color.bg, borderRadius: 999,
                        padding: '3px 10px', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap',
                    }}>
                        {status}
                    </span>
                );
            }
        },
        {
            id: 4,
            title: "Start Date",
            dataIndex: "startContractDate",
        },
        {
            id: 5,
            title: "End Date",
            dataIndex: "contractEndDate",
        },
        {
            id: 6,
            title: "Last Audit",
            width:'150px',

            dataIndex: "lastAuditDate",
        },
        {
            id: 7,
            title: "Next Audit",
            width:'150px',

            dataIndex: "nextAuditDate",
        },
        {
            id: 8,
            title: "Audit Status",
            dataIndex: "auditStatus",
            render: (status, record) => {
                const color = AuditStatusColors[status?.toLowerCase()] || { bg: '#f3f4f6', text: '#374151' };
                return (
                    <div style={{ opacity: 1, color: color.text, backgroundColor: color.bg, borderRadius: 6,  whiteSpace: 'nowrap', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                        {status}
                    </div>
                );
            }
        },
        {
            id: 9,
            title: "Key Group",
            dataIndex: "keygroup",
        },
        {
            id: 10,
            title: "Actions",
            dataIndex: "actions",
            fixed: "right",
            width:'100px',

            render: (_, record) => {

                // Once a key is actually back In House, Request Return/Mark as Returned no longer
                // apply - only Return to Customer does. Keeps the two lifecycles mutually exclusive
                // instead of Request Return reappearing (it would, if this only checked
                // returnRequested - that resets once the key's marked returned).
                const isInHouse = String(record?.record?.custodianType || "").toLowerCase().includes("house");

                // A placeholder for a key that never actually arrived - still waiting (Awaiting
                // Receipt) or the site got terminated before it ever showed up (Never Received).
                // Either way none of these actions apply to it (no custodian to request back from,
                // nothing lost/damaged to report, no group to move it into). Shown disabled rather
                // than hidden so the row still looks like every other row; completing it (while
                // still Awaiting Receipt) is done via the Edit button in the Site column instead.
                const placeholderStatus = String(record?.record?.status || "").toLowerCase();
                const isAwaitingReceipt = placeholderStatus === "awaiting receipt" || placeholderStatus === "never received";

                const items = [

                    {
                        key: "audit",
                        label: "Request Audit",
                        icon: <FontAwesomeIcon icon={faClipboardCheck} />,
                        onClick: () => {setKeyData(record); handleAction("Audit Request")},

                    },
                    {
                        type: "divider",
                    },
                    //  {
                    //     key: "edit",
                    //     label: "Edit Key",
                    //     icon: <FontAwesomeIcon icon={faEdit} />,
                    //     onClick: () => {setKeyToBeEdit(record); setNewKeyModal(true);},

                    // },
                    // {
                    //     key: "assign",
                    //     label: "Assign Key",
                    //     icon: <FontAwesomeIcon icon={faKey} />,
                    //     onClick: () => {setAssignModalVisible(true);},


                    // },
                    record?.record?.keyGroupId? null:
                    {
                        key: "addGroup",
                        label: "Add to Group",
                        icon: <FontAwesomeIcon icon={faGroupArrowsRotate} />,
                        onClick: () => {setKeyData(record); handleAction("Add To Group")},


                    },
                    {
                        key: "moveGroup",
                        label: "Move Group",
                        icon: <FontAwesomeIcon icon={faRotate} />,
                        onClick: () => {setKeyData(record); handleAction("Move Key Group")},


                    },

                    // Request Return / Mark as Returned - hidden entirely once In House, since
                    // Return to Customer takes over from there (see below). Mark as Returned is
                    // colored green (same "done" green used for the Returned status pill) so it
                    // reads as distinct from Request Return at a glance, not just a different icon.
                    ...(isInHouse ? [] : [
                        record?.record?.returnRequested ? {
                            key: "returned",
                            label: <span style={{color: '#16a34a', fontWeight: 600}}>Mark as Returned</span>,
                            icon: <SwapOutlined size={16} style={{color: '#16a34a'}} />,
                            onClick: () => {setKeyData(record); handleAction("Returned")},

                        }:
                        {

                            key: "return",
                            label: "Request Return",
                            icon: <FontAwesomeIcon icon={faRotateRight} />,
                            onClick: () => {setKeyData(record); handleAction("Request Return")},

                        },
                    ]),

                    // "Return to Customer" only makes sense once the key is actually back in-house
                    // - it was out with a supplier/employee before that, and has to come back
                    // (Request Return -> Mark as Returned) before there's anything to hand the
                    // customer. Showing it earlier would let someone "return" a key that's still
                    // physically with someone else.
                    ...(isInHouse ? [
                        {
                            type: "divider",
                        },
                        {
                            key: "returnToCustomer",
                            label: "Return to Customer",
                            icon: <FontAwesomeIcon icon={faRotateLeft} />,
                            onClick: () => {setKeyData(record); handleReturnToCustomerClick(record)},

                        },
                    ] : []),
                    {
                        type: "divider",
                    },
                    {
                        key: "replaceKey",
                        label: "Replace Key",
                        icon: <FontAwesomeIcon icon={faRotate} />,
                        className: "tour-key-replace-item",
                        onClick: () => {setKeyData(record); setReplaceKeyModal(true)},

                    },
                    {
                        key: "reportKeyDamaged",
                        label: "Report Damaged",
                        icon: <FontAwesomeIcon icon={faTriangleExclamation} />,
                        danger: true,
                        className: "tour-key-damage-item",
                        onClick: () => {setKeyData(record); setReportDamagedModal(true)},

                    },
                    {
                        key: "reportKeyGroupLost",
                        label: "Report Lost",
                        icon: <FontAwesomeIcon icon={faTriangleExclamation} />,
                        danger: true,
                        onClick: () => {setKeyData(record); handleAction("Report Lost")},

                    },
                ];

                const finalItems = isAwaitingReceipt
                    ? items.map((item) => (item && item.key ? { ...item, disabled: true } : item))
                    : items;

                const ItemToRender = record?.record?.returnToCustomer? [] : record?.record?.isKeyLost? [{

                    key: "found",
                    label: "Mark as found",
                    icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: 'green' }} />,
                    onClick: () => {setKeyData(record); handleAction("Mark as found")},


                }] : finalItems
                return (
                    <Dropdown
                        menu={{items: ItemToRender}}
                        trigger={["click"]}
                        placement="bottomRight"
                        disabled={record?.record?.returnToCustomer}
                    >
                        <Button
                            type="text"
                            icon={<MoreOutlined style={{ fontSize: 18 }} />}
                            style={{ borderRadius: 6 }}
                            data-tour="keyRegisterRowActions"
                        />
                    </Dropdown>
                );
            },
        },
    ];

    const AuditStatusColors = {
        // Grey — no date set, neutral
        "not scheduled": { bg: '#f3f4f6', text: '#6b7280', border: '#d1d5db' },

        // Green — no action needed
        completed:       { bg: '#dcfce7', text: '#166534', border: '#86efac' },
        scheduled:       { bg: '#ffedd5', text: '#9a3412', border: '#fdba74' },

        // Amber — needs attention soon
        upcoming:        { bg: '#fef9c3', text: '#854d0e', border: '#fde047' },
        pending:         { bg: '#ffedd5', text: '#9a3412', border: '#fdba74' },

        // Red — requires immediate action
        overdue:         { bg: '#fee2e2', text: '#991b1b', border: '#fca5a5' },
        missed:          { bg: '#fee2e2', text: '#991b1b', border: '#fca5a5' },
    };


// ================================================
// ==================== KEY CAGE
// ================================================

    const [keyGroupData, setKeyGroupData] = useState(null);
    const [assignModalVisible, setAssignModalVisible] = useState(false);



         
    const [actionModalVisible, setActionModalVisible] = useState(false);
    const [actionType, setActionType] = useState(null);
    const handleAction = (type) => {
        setActionType(type);
        setActionModalVisible(true);
    };

    // Confirm action helper
    const showConfirm = (action, config) => {
        Swal.fire({
            title: config.title,
            text: config.text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#f44336',
            cancelButtonColor: '#6b7280',
            confirmButtonText: config.confirmText,
        }).then((result) => {
            if (result.isConfirmed) {
                handleAction(action);
            }
        });
    };

    const [reportKeyGroupLost, {loading: reporKeyGroupLostLoading}] = useMutation(lostKeyGroupMutation,{
        onCompleted: (data)=>{
            message.success(data?.lostKeyGroup?.message || "Key reported lost successfully");
            allKeyGroupDataRefetch();
        },
        onError: (error)=>{
            message.error(error?.message || "Failed to report key as lost");
        }
    });

    const [requestKeyGroupReturn, {loading: requestKeyGroupReturnLoading}] = useMutation(requestReturnKeyGroupMutation, {
        onCompleted: (data)=>{
            message.success(data?.requestReturnKeyGroup?.message || "Return requested successfully");
            allKeyGroupDataRefetch();
        },
        onError: (error)=>{
            message.error(error?.message || "Failed to request return");
        }
    });


    const [returnKeyGroup, {loading: returnKeyGroupLoading}] = useMutation(returnKeyGroupMutation, {
        onCompleted: (data)=>{
            message.success(data?.returnKeyGroup?.message || "Key returned successfully");
            allKeyGroupDataRefetch();
        },
        onError: (error)=>{
            message.error(error?.message || "Failed to return key");
        }
    });

    const [markAsFoundKeyGroup, {loading: markAsFoundKeyGroupLoading}] = useMutation(markAsFoundKeyGroupMutation);






    const handleKeyGroupActionSubmit = async (type, form, record) => {
        try{
            const values = await form.getFieldsValue();
             // Handle form submission for different actions
            switch(type){
                case 'Request Return':
                    // Call API to request return with values
                    requestKeyGroupReturn({variables: {input: {...values, _id: keyGroupData._id}}});
                    break;
                case 'Audit Request':
                    // Call API to submit audit request with values
                    message.success("Audit request submitted successfully");
                    break;
                case 'Report Lost':
                    // Call API to report key as lost with values
                    reportKeyGroupLost({variables: {input: {...values, _id: keyGroupData._id}}});
                    break;

                case 'Returned':
                    // Call API to mark key as returned with values
                    returnKeyGroup({variables: {input: {...values, _id: keyGroupData._id}}});
                    break;



                case 'Mark as found':
                    markAsFoundKeyGroup({
                        variables:{
                            input:{
                                ...values,
                                _id: keyGroupData._id
                            }
                        }
                    })
                    break;
                default:
                    break;
            }
            setActionModalVisible(false);
            form.resetFields();
        }catch (error){
            console.error("Action Failed:", error, keyGroupData);
            message.error("Failed to perform action");
            return;
        }

    };

    const [deleteKeyGroup, {loading: deleteKeyGroupLoading}] = useMutation(DELETE_KEY_GROUP_Mutation,{
        onCompleted: (data)=>{
            message.success("Group deleted successfully");

        },
        onError: (data)=>{
            message.error(error?.message || "Failed to delete key group");

        }
    });

    const actionMenu = (record) => (
        <Menu
            onClick={async ({ key, domEvent }) => {
                domEvent?.stopPropagation?.();
                setKeyGroupData(record); // ✅ exact clicked record id

                if (key === "assign") {
                    setAssignModalVisible(true);
                    return;
                }

                if (key === "return") {
                    // whatever your logic is, use record
                    handleAction("Request Return");
                    return;
                }

                if (key === "returned") {
                    // whatever your logic is, use record
                    handleAction("Returned");
                    return;
                }

                if (key === "audit") {
                    handleAction("Audit Request");
                    return;
                }

                if (key === "found") {
                    handleAction("Mark as found");
                    return;
                }

                if (key === "lost") {
                    showConfirm("Report Lost", {
                    title: "Report Key as Lost?",
                    text: "This will mark the key as lost and require additional documentation.",
                    confirmText: "Yes, Report Lost",
                    onConfirm: () => handleAction("Report Lost"), // optional
                    });
                }

                if(key === "delete") {
                    const result = await Swal.fire({
                        title: "Delete Key Group?",
                        text: "Are you sure you want to delete this key group? This action cannot be undone.",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#d33",
                        cancelButtonColor: "#6c757d",
                        confirmButtonText: "Delete",
                        cancelButtonText: "Cancel",
                    });
                    if (result.isConfirmed) {
                        await deleteKeyGroup({ variables: { keyGroupId: record?._id } });
                        await allKeyGroupDataRefetch();
                    }
                }

            }}
        >
        {
            record?.isKeyLost?
            <Menu.Item key="found" icon={<FontAwesomeIcon icon={faCheckCircle} style={{ color: 'green' }} />} >
                Mark as Found
            </Menu.Item>
            
            :

            <>            
                {!record?.custodianId && (
                    <Menu.Item key="assign" icon={<FontAwesomeIcon icon={faBoxesStacked} />}>
                        Assign Group
                    </Menu.Item>
                )}

                {/* {record?.custodianId && ( */}
                <>
                    {record?.returnRequested ? (
                    <Menu.Item key="returned" icon={<SwapOutlined size={16} style={{color: '#16a34a'}} />} style={{color: '#16a34a', fontWeight: 600}}>
                        Mark as Returned
                    </Menu.Item>
                    ) : (
                    // There's nothing to request back from until the group is actually assigned to
                    // someone - keep it visible (so it's discoverable) but disabled until then,
                    // rather than letting a return get requested against no custodian at all.
                    <Menu.Item key="return" icon={<FontAwesomeIcon icon={faRotateRight} />} disabled={!record?.custodianId}>
                        Request Return
                    </Menu.Item>
                    )}
                </>
                {/* )} */}

                {/* <Menu.Item key="audit" icon={<FontAwesomeIcon icon={faClipboardCheck} />}>
                    Request Audit
                </Menu.Item> */}

                <Menu.Divider />
                {
                   record?.keysCount>0?
                    <Menu.Item
                        key="lost"
                        icon={<FontAwesomeIcon icon={faTriangleExclamation} />}
                        danger
                    >
                        Report Lost
                    </Menu.Item>

                    :

                    <Menu.Item
                        key="delete"
                        icon={<FontAwesomeIcon icon={faTrashCan} />}
                        danger
                    >
                        Delete Key Group
                    </Menu.Item>

                }


            </>

        }
             
        </Menu>
    );

    const keyGrpColumns = [
        {
            id: 3,
            title: "Assignee",
            dataIndex: "assignee",
            render: (text) => (
                <span style={{ color: text ? '#333' : '#bbb' }}>
                    {text || '—'}
                </span>
            )
        },
        {
            id: 0,
            title: "Key Group",
            dataIndex: "name",
            render: (item, record) => {
                const isShow = record?._id === hoveredRow;
                return (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
                        <span >
                            {item}
                        </span>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <button
                                onClick={() => { setCurrentViewStatus("allKey");  setAllKeyFilters({...allKeyFilters, keyGroupId: {name:record?.name, _id:record?._id}})}}
                                style={{
                                    visibility: isShow ? 'visible' : 'hidden',
                                    
                                }}
                                className="sm-btn"
                            >
                                View Keysets
                            </button>

                            <button
                                onClick={() => { setNewGroupModal(true); setGroupToBeEdit(record); }}
                                style={{
                                    visibility: isShow ? 'visible' : 'hidden',
                                
                                }}
                                className="sm-btn"
                            >
                                Edit
                            </button>
                        </div>
                    </div>
                );
            }
        },
        {
            id: 1,
            title: "Description",
            dataIndex: "description",
            width:'200px',
            render: (text) => (
                <span style={{ color: text ? '#333' : '#bbb' }}>
                    {text || '—'}
                </span>
            )
        },
        // {
        //     id: 2,
        //     title: "Zone",
        //     dataIndex: "zone",
        //     render: (text) => (
        //         <span style={{ color: text ? '#333' : '#bbb' }}>
        //             {text || '—'}
        //         </span>
        //     )
        // },
        {
            id: 6,
            title: "Total Keysets",
            dataIndex: "status",
            render: (status, record) => {
                const count = record?.keysCount || 0;
                return (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        {count}  {count === 1 ? "Total Keys" : "Total Keysets"}

                        <Dropdown
                            overlay={
                                actionMenu(record?.record)
                            }
                            trigger={["click"]}
                            placement="bottomRight"
                        >
                            <div
                                style={{
                                    width: '28px',
                                    height: '28px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    transition: 'background 0.2s',
                                }}
                                className="action-icon-btn"
                            >
                                <FontAwesomeIcon icon={faEllipsisVertical} style={{ fontSize: '14px', color: '#888' }} />
                            </div>
                        </Dropdown>
                    </div>
                );
            }
        }
    ];

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    const [auditPopoverOpen, setAuditPopoverOpen] = useState(false);
    const [keyCagePopoverOpen, setKeyCagePopoverOpen] = useState(false);
    const [keyStatusPopoverOpen, setKeyStatusPopoverOpen] = useState(false);

    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedKeys) => {
          setSelectedRowKeys(selectedKeys);
        },
    };

    const [getAllKeys, {data: allKeyData , loading: allKeyLoading, refetch: allKeyRefetch} ]= useLazyQuery(getAllKeysQuery);


    const [getAllKeyGroups, {data: allKeyGroupData, loading: allKeyGroupLoading, refetch: allKeyGroupDataRefetch}] = useLazyQuery(getAllKeyGroupsQuery, {
        fetchPolicy: 'network-only'
    });



    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);


    useEffect(()=>{
        if(currentViewStatus=="allKey" && !allKeyLoading && allKeyData?.getAllKeys?.response){
            const data = allKeyData?.getAllKeys?.response?.map((res)=>{
               
                return({
                    _id: res?._id,
                    assignee: res?.custodianDetail?.name || "--",
                    site: res?.site?.sitename,
                    postcode: res?.site?.postcode,
                    keytypes: res?.keyTypes?.map((key)=> key?.type[0]?.toUpperCase()+key?.type.slice(1, key?.type?.length)+" ").join(", "),
                    custodianType: res?.custodianType,
                    receivedAt: formatDate(res?.dateReceived),
                    totalkeys: res?.keyTypes?.reduce((accumulator, key) => accumulator + key?.count,
                    0,),
                    keySerial: res?.keySerial,
                    keygroup: res?.keygroup?.name || "--",
                    assignmentDate: res?.assignmentDate || "--",
                    status: res?.status,
                    record: res,
                    auditStatus: res?.auditNextDate && dayjs(res.auditNextDate).isBefore(dayjs(), 'day') ? "Overdue" : (res?.auditStatus || "Not Scheduled"),
                    contractEndDate: res?.site?.contractEndDate ? formatDate(res?.site?.contractEndDate) : "--",
                    startContractDate: res?.site?.contractStartDate ? formatDate(res?.site?.contractStartDate) : "--",
                    lastAuditDate: res?.auditLastDate ? formatDate(res?.auditLastDate) : "--",
                    nextAuditDate: res?.auditNextDate ? formatDate(res?.auditNextDate) : "--",
                });
            });
            setDataSource([...data]);
            setTotalCount(allKeyData?.getAllKeys?.totalCount)

        }else if(currentViewStatus=="keygroups" && !allKeyGroupLoading && allKeyGroupData?.getKeyGroups?.response){
           

            const data = allKeyGroupData?.getKeyGroups?.response?.map((res)=>{
                return({
                    _id: res?._id,
                    name: res?.name,
                    description: res?.description || "--",
                    zone: res?.zone?.name || "--",
                    assignee: res?.custodianDetail?.name || "--",
                    custodianType: res?.custodianType || "--",
                    record: res,
                    keysCount: res?.keysCount|| 0,
                    status: res?.status || "UnAssigned"
                });
            });
            setTotalCount(allKeyGroupData?.getKeyGroups?.totalCount)
            setDataSource([...data]);
        }
    },[currentViewStatus, allKeyGroupData?.getKeyGroups?.response, allKeyData?.getAllKeys?.response, allKeyGroupLoading, allKeyLoading]);
   
  
  
    const handleRowMouseEnter = (record) => {
        setHoveredRow(record._id);
      };
    
    
      const handleRowMouseLeave = () => {
        setHoveredRow(null);
    
      };


    const searchRef = useRef();

    // Debounced version - only delays committing the search value (and only resets to page 1
    // when a *new* search is actually applied); the fetch itself always runs through the single
    // combined effect below so it carries whatever filters/page are current, instead of a
    // search request silently wiping out active filters (or vice versa).
    const debouncedSetSearch = useCallback(
        debounce((input) => {
            setDebouncedSearchValue(input || null);
            setPage(1);
        }, 500), // 500ms delay
        [] // dependencies
    );

    useEffect(()=>{
        setSearchText('');
        setDebouncedSearchValue(null);
        debouncedSetSearch.cancel();
        setPage(1);
        setPageSize(20);
    },[currentViewStatus]);


    const [allKeyFilters, setAllKeyFilters] = useState({});

    // Single source of truth for fetching the current tab's data - always sends search, filters
    // and pagination together (whichever changed), so changing one never resets the others.
    const fetchCurrentView = useCallback(() => {
        const cleanedFilters = Object.fromEntries(
            Object.entries(allKeyFilters || {}).filter(([_, value]) => value !== null && value !== undefined)
        );
        const filters = Object.keys(cleanedFilters).length > 0
            ? {...cleanedFilters, keyGroupId: cleanedFilters?.keyGroupId?._id || null}
            : null;

        if(currentViewStatus=="allKey"){
            getAllKeys({
                variables:{
                    input:{
                        filters,
                        search: debouncedSearchValue || null,
                        pageSize: pageSize,
                        page: page
                    }
                },
                fetchPolicy: 'network-only'
            });
        }else if(currentViewStatus=="keygroups"){
            getAllKeyGroups({
                variables:{
                    input:{
                        search: debouncedSearchValue || null,
                        pageSize: pageSize,
                        page: page
                    }
                },
                fetchPolicy: 'network-only'
            });
        }
    }, [currentViewStatus, page, pageSize, allKeyFilters, debouncedSearchValue]);

    useEffect(() => {
        fetchCurrentView();
    }, [fetchCurrentView]);



    return(
        <div style={{ 
            padding: '25px 48px',
          }}>
      
            <div 
            style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'flex-start',
                marginBottom: '0px',
            }}
            >
    
            <div className='grid-title'>
                {currentViewStatus=="allKey"? " Keys " : "Key Group "}
                <span className='grid-subtitle'>
                    {totalCount} records  &emsp;
                    
                </span>
            </div>
    
    
            <Space size={12}>
                <Button 
                    onClick={()=>{
                        if(currentViewStatus=="allKey"){
                            setNewKeyModal(true)
                        }else{
                            setNewGroupModal(true);
                        }
                    }}
                    className="grid-filed-btn"
                >
                  {currentViewStatus=="allKey"? " Register New Key " : "New Key Group"} 
                </Button>
            </Space>
    
            </div>
      
            <div
                className='setting-body-inner grid-tabs' style={{
                padding: '10px 0px', 
                // display: 'flex', alignItems:'center'
                }}
            >
                <Tabs
                    items={[
                        {
                            key: 'allKey',
                            label: 'Keys',
                        },
        
                        {
                            key: 'keygroups',
                            label: 'Key Group',
                        },
        
        
                    ]}
                    onChange={(e)=>{setCurrentViewStatus(e); setDataSource([]); }}
                    activeKey={currentViewStatus}
                />
    
            </div>
            


        {/* Enhanced Search & Filter Container */}
        
          <div style={{ 
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '12px',
            marginTop:'-12px'
          }}>

            <div style={{ display: 'flex', gap: '12px', flex: 1 }}>
            
                <Input
                    ref={searchRef}
                    placeholder={
                        currentViewStatus=="allKey"?
                        "Search by KeyGroup, Customer, Site, Postcode, Assignee ..."
                        :
                        "Search by Assignee, Key group or Zone ..."
                    }
                    value={searchText}
                    onChange={(e) => { setSearchText(e.target.value); debouncedSetSearch(e.target.value); }}
                    className="generic-input-control"
                  
                    suffix={<FontAwesomeIcon icon={faSearch} style={{color:'#0091ae'}}/>}

                    style={{
                        width:'min(500px, 100%)', 
                        maxWidth:'500px',
                        height: '40px',
                        borderRadius: '14px',
                        border: '2px solid #e5e7eb',
                        transition: 'all 0.3s ease'
                    }}
                    allowClear
                    onFocus={(e) => {
                        e.target.style.borderColor = '#00bda5';
                        e.target.style.boxShadow = '0 0 0 4px rgba(0, 189, 165, 0.1)';
                    }}
                    onBlur={(e) => {
                        e.target.style.borderColor = '#e5e7eb';
                        e.target.style.boxShadow = 'none';
                    }}
                />

                {currentViewStatus=="allKey"? 
                
                <>

                    <FilterPopover
                        label="Audit Status"
                        open={auditPopoverOpen}
                        onOpenChange={setAuditPopoverOpen}
                        items={["Not Scheduled", "Upcoming", "Scheduled", "Overdue"]}
                        value={allKeyFilters['auditStatus']||null}
                        onSelect={(value) => {
                            setAllKeyFilters(prev => ({
                                ...prev,
                                auditStatus: prev.auditStatus === value ? undefined : value
                            }));
                            setPage(1);
                        }}
                    />


                    <FilterPopover
                        label="Key Status"
                        open={keyStatusPopoverOpen}
                        onOpenChange={setKeyStatusPopoverOpen}
                        items={["Live", "Lost", 'Return Requested',"Return"]}
                        value={allKeyFilters['keyStatus']||null}
                        onSelect={(value) => {
                            setAllKeyFilters(prev => ({
                                ...prev,
                                keyStatus: prev.keyStatus === value ? undefined : value
                            }));
                            setPage(1);
                        }}
                    />


                    {
                        allKeyFilters?.keyGroupId &&
                        <FilterPopover
                            label="Key Group"
                            open={false}
                            onOpenChange={setKeyCagePopoverOpen}
                            items={[]}
                            value={allKeyFilters?.keyGroupId?.name ||null}
                            onSelect={(value) => {
                                setAllKeyFilters(prev => ({
                                    ...prev,
                                    keyGroupId: null
                                }));
                                setPage(1);
                            }}
                        />
                    }

                    

                
                
                </>
                : null}


            </div>

          </div>

        

            <div className='tableView mobileTable'>
                <Layout className='bg-white all-module-grid'>
                    <Content className="site-layout">
                        <Table
                            // rowSelection={rowSelection}
                            columns={
                                currentViewStatus=="allKey"? keyColumns : keyGrpColumns
                            }
                            dataSource={dataSource}
                            loading={
                                allKeyGroupLoading || allKeyLoading || deleteKeyGroupLoading ||
                                reporKeyGroupLostLoading || requestKeyGroupReturnLoading || returnKeyLoading || returnKeyGroupLoading || markAsFoundKeyGroupLoading
                                || requestKeyReturnLoading || lostKeyLoading || markAsFoundKeyLoading || returnKeyToCustomerLoading || moveKeyToGroupLoading || addKeyToGroupLoading || makeAuditRequestLoading
                            }
                            style={{
                                borderRadius: '8px',
                            }}
                            rowClassName={(record, index) => 
                                index === 0 ? 'selected-row' : ''
                            }
                            className="curvedTable"
                            pagination={false}
                
                            
                            
                            sticky
                            scroll={{ x:  'max-content'
                            }}


                            onRow={(record) => ({
                                onMouseEnter: () => handleRowMouseEnter(record),
                                onMouseLeave: () => handleRowMouseLeave(),
                            })}
                            
                        />


                        <div className='table-pagination-bar'>
                            <Pagination
                                current={page}
                                pageSize={pageSize}
                                total={totalCount}
                                showSizeChanger={true}
                                pageSizeOptions={["10", "20", "50", "100"]}
                                onChange={(page, size) => {
                                setPage(page);
                                setPageSize(size);
                                }}
                            />
                        </div>


                    </Content>
                </Layout>
            </div>

            {
                newKeyModal ?
                <NewKeyModal
                    visible={newKeyModal}
                    close={()=>{setNewKeyModal(false); setKeyToBeEdit(null); allKeyRefetch(); }}
                    keyToBeEdit={keyToBeEdit}
                />
                : null
            }

            {
                newKeyGroupModal?
                <NewKeyGroupModal 
                    visible={newKeyGroupModal}
                    close={()=>{setNewGroupModal(false); setGroupToBeEdit(null); allKeyGroupDataRefetch(); }}
                    groupToBeEdit={groupToBeEdit}
                />
                : null
            }

            {

                (keyDetailModal?.modal==true && keyDetailModal?.id)?
                <KeyDetailPage 
                    visible={keyDetailModal?.modal}
                    close={()=>{setKeyDetailModal({modal: false, id:null});  allKeyRefetch(); }}
                    keyId={keyDetailModal?.id}
                />
                :null
            }    


            {/* Assign Group Modal */}
            <AssignGroupModal
                visible={assignModalVisible}
                onClose={()=>{
                    setAssignModalVisible(false); setKeyGroupData(null); setKeyData(null);
                    fetchCurrentView();
                }}
                idToBeEdit={keyGroupData?._id || keyData?._id}
                assignType={currentViewStatus=="allKey"? "allKey": "group"}
            />
            
            <KeyActionModal 
                visible={actionModalVisible}
                type={actionType}
                record={currentViewStatus=="allKey"? keyData?.record : keyGroupData?.record}
                close={()=>setActionModalVisible(false)}
                handleActionSubmit={
                    (type, form, customerId=null)=>{
                        if(currentViewStatus=="allKey"){
                            
                            handleKeyActionSubmit(type, form, customerId);

                        }else{
                            handleKeyGroupActionSubmit(type, form)
                        }
                    }
                }
                loading={reporKeyGroupLostLoading || requestKeyGroupReturnLoading || returnKeyLoading || returnKeyGroupLoading || markAsFoundKeyGroupLoading
                    || requestKeyReturnLoading || lostKeyLoading || markAsFoundKeyLoading || returnKeyToCustomerLoading || moveKeyToGroupLoading || addKeyToGroupLoading || makeAuditRequestLoading
                }
            />

            {
                replaceKeyModal &&
                <ReplaceKeyModal
                    visible={replaceKeyModal}
                    keyId={keyData?.record?._id}
                    close={()=>{setReplaceKeyModal(false); setKeyData(null);}}
                    onComplete={()=>allKeyRefetch()}
                />
            }

            {
                reportDamagedModal &&
                <ReportKeyDamagedModal
                    visible={reportDamagedModal}
                    keyId={keyData?.record?._id}
                    close={()=>{setReportDamagedModal(false); setKeyData(null);}}
                    onComplete={()=>allKeyRefetch()}
                />
            }

            <TerminateSiteModal
                open={!!terminateSiteForKey}
                onCancel={()=>setTerminateSiteForKey(null)}
                onConfirm={handleTerminateSiteForKeyConfirm}
            />

            <SiteTerminationCheckModal
                open={!!terminationImpact}
                siteId={terminationImpact?.siteId}
                contractEndDate={terminationImpact?.contractEndDate}
                impact={terminationImpact}
                checking={terminationCheckLoading}
                onRefresh={async ()=>{
                    const res = await getSiteTerminationImpact({variables: {siteId: terminationImpact?.siteId, contractEndDate: terminationImpact?.contractEndDate}});
                    setTerminationImpact({...(res?.data?.getSiteTerminationImpact ?? null), siteId: terminationImpact?.siteId, contractEndDate: terminationImpact?.contractEndDate});
                }}
                onCancel={()=>setTerminationImpact(null)}
                onProceed={handleTerminationProceed}
            />

        </div>
    )
}


const AssignGroupModal = ({ visible, onClose, idToBeEdit, assignType }) => {
    
    const [assignForm] = Form.useForm();

    
    
    const [getAgencyQuery, {data: agencyData, loading: agencyLoading}] = useLazyQuery(getAgencies);
     
    const handelSupplierSearch = async(input)=>{
    await getAgencyQuery(
        {fetchPolicy: 'cache-and-network',
            variables: {
                input: {
                    filters: {
                        advanceFilter: [
                        [{
                            operator: "suppliername",
                            condition: "and",
                            filter: "contain_exactly",
                            filterValue: [input]
                        }]
                        ]
                    },
                    page: 1,
                    pageSize: 5,
                }
            }
        }
    );
    };

    // Debounced version
    const debouncedSupplierSearch = useCallback(
        debounce((input) => {
            if(input?.length>2){
                handelSupplierSearch(input);
            }
        }, 500), // 500ms delay
        [] // dependencies
    );

    const [getEmployeeQuery, {data: employeeData, loading: employeeDataLoading}] = useLazyQuery(GetEmployeeRecord);

    const handelEmployeeSearch = async(input)=>{
        await getEmployeeQuery(
            {
                variables: {
                    input: {
                        filters: null,
                        search: input,
                        page: 1,
                        pageSize: 5,
                    }
                },
                fetchPolicy: 'cache-and-network'
            }
        );
    };
    
    
      // Debounced version
      const debouncedEmployeeSearch = useCallback(
        debounce((input) => {
            if(input?.length>2){
                handelEmployeeSearch(input);
            }
        }, 500), // 500ms delay
        [] // dependencies
      );

    const[assignKeyGroup, {loading: assignKeyGroupLoading}] = useMutation(assignKeyGroupMutation);


    const [assignKey, {loading: assignKeyLoading}] = useMutation(assignKeyMutation);


    const handleSave = async() => {
        try{
            if(assignType=="allKey"){
                const values = await assignForm.validateFields();
                
                await assignKey({
                    variables:{
                        input: {
                            ...values,
                            _id: idToBeEdit,
                        }
                    }
                });



            }else{
            
                const values = await assignForm.validateFields();
                await assignKeyGroup({variables: {input: {...values, _id: idToBeEdit}}});
            
            }

        }catch (err){
            message.error(err?.message || "Failed while assign key group")
        }finally{
            onClose();
        }
    };

    return(
            <Modal
                visible={visible}
                width={560}
                closable={false}
                footer={
                    <div className="drawer-footer" style={{padding:'16px 40px', paddingBottom:'16px', justifyContent:'right', flexDirection:'row-reverse', display:'flex', columnGap:'16px', marginTop:'-25px' }}>
                        <button  
                        disabled={assignKeyGroupLoading || assignKeyLoading} 
                        className={assignKeyGroupLoading || assignKeyLoading ? 'disabled-btn drawer-filled-btn' : 'drawer-filled-btn'} 
                        onClick={handleSave}
                        >
                            Assign
                        </button>

                        <button disabled={assignKeyGroupLoading || assignKeyLoading} className={assignKeyGroupLoading || assignKeyLoading ? 'disabled-btn drawer-outlined-btn': 'drawer-outlined-btn'} onClick={()=>{onClose();}}>
                            Cancel
                        </button>
                    </div>
                }


            >

                <div className='modal-header-title'>
                    <span style={{letterSpacing:'0.2px'}}> Assign Keys </span>
                    <span  onClick={onClose}><FontAwesomeIcon className='close' icon={faClose}/></span>
                </div>

                <div className='modal-body' style={{margin:'16px 0'}}>
                    <Form initialValues={{custodianType: "supplier"}} form={assignForm} style={{gap:'16px', display:'flex', flexDirection:'column'}} requiredMark={false} layout="vertical" name="assignGroupForm">
                        <Form.Item
                            name="custodianType"
                            label="Custodian Type"
                            rules={[{ required: true, message: 'Please select custodian type' }]}
                        >
                            <Select placeholder="Select custodian type" className='custom-select' suffixIcon={<CaretDownFilled/>}>
                                <Select.Option value="employee">Employee</Select.Option>
                                <Select.Option selected value="supplier">Supplier</Select.Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            shouldUpdate={(prev, curr) => prev.custodianType !== curr.custodianType}
                        >
                            {({ getFieldValue, setFieldsValue }) => {
                                const method = getFieldValue("custodianType");


                                if (!method) return null; // hide field until type is selected

                                const options =
                                method === "employee"
                                    ? employeeData?.getEmployee?.response?.map(emp => (
                                        <Select.Option key={emp._id} value={emp._id}>
                                        {emp.firstname + " " + (emp.lastname || "")}
                                        </Select.Option>
                                    ))
                                    : agencyData?.agencies?.agencies?.map(agency => (
                                        <Select.Option key={agency._id} value={agency._id}>
                                        {agency.suppliername}
                                        </Select.Option>
                                    ));

                                return (
                                <Form.Item
                                    name="custodianId"
                                    label="Custodian"
                                    rules={[{ required: true, message: "Please select custodian" }]}
                                >
                                    <Select
                                    placeholder={method === "employee" ? "Search employee by name" : "Search supplier by name"}
                                    showSearch
                                    filterOption={false}
                                    className="custom-select"
                                    suffixIcon={<CaretDownFilled />}
                                    loading={employeeDataLoading || agencyLoading}
                                    onSearch={
                                        method === "employee"
                                        ? debouncedEmployeeSearch
                                        : debouncedSupplierSearch
                                    }
                                    >
                                    {employeeDataLoading || agencyLoading ? (
                                        <Select.Option>
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <Spinner />
                                        </div>
                                        </Select.Option>
                                    ) : (
                                        options
                                    )}
                                    </Select>
                                </Form.Item>
                                );
                            }}
                        </Form.Item>

                        <Form.Item
                            name="assignmentDate"
                            label="Assignment Date"
                            rules={[{ required: true, message: 'Please select assignment date' }]}
                        >
                            <DatePicker format={"DD/MM/YYYY"} style={{ width: '100%' }} className='generic-input-control'/>
                        </Form.Item>

                        <Form.Item name="assignmentNotes" label="Assignment Notes">
                            <TextArea rows={3} placeholder="Additional notes for group assignment" className='generic-input-control' />
                        </Form.Item>
                    </Form>
                </div>


            </Modal>
    );

}